import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiRoutes } from 'app/routes/app.routes';
import { HttpService } from '../http/http.service';

@Injectable({
  providedIn: 'root',
})
export class DepartmentsService {
  private baseUrl = ApiRoutes.api.baseUrl;
  private routes = ApiRoutes.api;
  constructor(private http: HttpClient, private httpService: HttpService) {}

  addDepartment(payload: any) {
    return this.httpService.makeRequest({
      path: this.routes.department.add,
      method: 'post',
      options: { body: payload },
      loader: { type: 'spinner' },
      isAuthRoutes: true
    });
  }

  allDepartments(pagination?: { page?: number; limit?: number }) {
    const params: any = {};
    
    if (pagination) {
      if (pagination.page) params.page = pagination.page;
      if (pagination.limit) params.limit = pagination.limit;
    }
    
    return this.httpService.makeRequest({
      path: this.routes.department.retrieve,
      method: 'get',
      options: { params },
      loader: { type: 'spinner' },
      isAuthRoutes: true
    });
  }

  editDepartment(id: string, payload: any) {
    return this.httpService.makeRequest({
      path: this.routes.department.edit,
      method: 'put',
      options: { id, body: payload },
      loader: { type: 'spinner' },
      isAuthRoutes: true
    });
  }

  deleteDepartment(id: string) {
    return this.httpService.makeRequest({
      path: this.routes.department.delete,
      method: 'delete',
      options: { id },
      loader: { type: 'spinner' },
      isAuthRoutes: true
    });
  }

  bulkDelete(payload: { ids: number[] }) {
    return this.httpService.makeRequest({
      path: this.routes.department.bulkDelete,
      method: 'delete',
      options: { body: payload },
      loader: { type: 'spinner' },
      isAuthRoutes: true
    });
  }

  getDepartmentsBySpecialization(specializationId: number) {
    return this.httpService.makeRequest({
      path: this.routes.department.retrieve,
      method: 'get',
      options: { params: { specialization: specializationId } },
      loader: { type: 'spinner' },
      isAuthRoutes: true
    });
  }

  getDepartmentDetails(id: number) {
    return this.httpService.makeRequest({
      path: this.routes.department.retrieveSingle,
      method: 'get',
      options: { id },
      loader: { type: 'spinner' },
      isAuthRoutes: true
    });
  }
}
